'use client';
import { Breakpoints } from '@lichtblick/theme';
import { useEffect, useState } from 'react';
export const useIsMobile = ()=>{
    const [isMobile, setIsMobile] = useState(true);
    useEffect(()=>{
        const mediaQuery = window.matchMedia(`(max-width: ${Breakpoints.Tablet - 1}px)`);
        const handleMediaChange = (event)=>{
            setIsMobile(event.matches);
        };
        mediaQuery.addEventListener('change', handleMediaChange);
        return ()=>mediaQuery.removeEventListener('change', handleMediaChange);
    }, []);
    return {
        isMobile
    };
};

//# sourceMappingURL=use-mobile.js.map